import React, { useState } from "react"
import { useHistory } from "react-router-dom"

import AppLayout from "@cloudscape-design/components/app-layout"
import TopNavigation from "@cloudscape-design/components/top-navigation"
import ContentLayout from "@cloudscape-design/components/content-layout"
import Header from "@cloudscape-design/components/header"
import SpaceBetween from "@cloudscape-design/components/space-between"
import BreadcrumbGroup from "@cloudscape-design/components/breadcrumb-group"
import Spinner from "@cloudscape-design/components/spinner"
import Container from "@cloudscape-design/components/container"
import AppHelpPanel from "./help-panel"

const PageLayout = ({
  children,
  title,
  description,
  loading,
  breadcrumbs = [],
  spacing = "large",
  onLogout,
  username,
  userRole,
}) => {
  const history = useHistory()
  const [toolsOpen, setToolsOpen] = useState(false)
  
  const handleLogout = () => {
    if (onLogout) {
      onLogout()
    } else {
      // Default logout behavior
      window.location.href = '/login'
    }
  }

  // Build breadcrumb items for Cloudscape
  const breadcrumbItems = breadcrumbs.length > 0 
    ? [
        ...breadcrumbs.map(({ title, path }) => ({
          text: title,
          href: path
        })),
        { text: title, href: '#' }
      ]
    : [];

  return (
    <>
      <div id="top-nav">
        <TopNavigation
          identity={{
            href: "/",
            title: "WW FSI Document Management - REGISTRY",
            logo: {
              src: "/aws-logo.png",
              alt: "AWS Logo"
            }
          }}
          utilities={[
            {
              type: "button",
              iconName: "status-info",
              title: "Help",
              ariaLabel: "Help",
              onClick: () => setToolsOpen(!toolsOpen)
            },
            {
              type: "menu-dropdown",
              text: username ? `${username}${userRole ? ` [${userRole}]` : ''}` : "User",
              iconName: "user-profile",
              items: [
                {
                  id: "logout",
                  text: "Logout"
                }
              ],
              onItemClick: ({ detail }) => {
                if (detail.id === "logout") {
                  handleLogout()
                }
              }
            }
          ]}
        />
      </div>
      <AppLayout
        headerSelector="#top-nav"
        navigationHide={true}
        tools={<AppHelpPanel />}
        toolsOpen={toolsOpen}
        onToolsChange={({ detail }) => setToolsOpen(detail.open)}
        content={
          <ContentLayout
            header={
              <SpaceBetween size="m">
                {breadcrumbItems.length > 0 && (
                  <BreadcrumbGroup
                    items={breadcrumbItems}
                    onFollow={(event) => {
                      event.preventDefault();
                      if (event.detail.href && event.detail.href !== '#') {
                        history.push(event.detail.href);
                      }
                    }}
                  />
                )}
                <Header
                  variant="h1"
                  description={description}
                >
                  {title}
                </Header>
              </SpaceBetween>
            }
          >
            {loading ? (
              <Container>
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <Spinner size="large" />
                </div>
              </Container>
            ) : (
              <SpaceBetween size={spacing === "large" ? "l" : "m"}>
                {children}
              </SpaceBetween>
            )}
          </ContentLayout>
        }
      />
    </>
  )
}

export default PageLayout